<template>
  <div>
    <div class="mt-4 text-center">
      <v-dialog v-model="dialog" persistent scrollable>
        <v-card>
          <v-card-title>
            <v-row>
              <v-col lg="4" md="4" sm="4" class="col-12">
                <v-select
                  :items="planillaOpciones"
                  v-model="planilla"
                  label="Seleccione Planilla"
                  class="mt-4 pa-0 sel-popup"
                >
                </v-select>
              </v-col>
              <v-col lg="4" md="4" sm="4" class="col-12">
                <v-select :items="sexoOpciones" v-model="sexo" label="Seleccione Sexo" class="mt-4 pa-0 sel-popup">
                </v-select>
              </v-col>
              <v-col lg="4" md="4" sm="4" class="col-12">
                <v-text-field
                  class="mt-4"
                  v-model="search"
                  append-icon=" fas fa-search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-divider></v-divider>
              <v-col class="col-12">
                <v-data-table
                  v-model="empleadosSelect"
                  :headers="cabeceraEmpleado"
                  :items="empleados"
                  item-key="idtrabajador"
                  class="border"
                  :search="search"
                  :items-per-page="10"
                  :single-select="selected"
                  show-select
                  :loading="loading"
                  :mobile-breakpoint="0"
                  loading-text="Cargando... Espere un nomento"
                  no-results-text="No se encontraron datos"
                  no-data-text="No se encontraron datos"
                >
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="cancelar()">Cancelar</v-btn>
            <v-btn color="primary" text @click="asignarEmpleados()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import AsignacionService from '../services/AsignacionService';

export default {
  name: 'EmpleadosListado',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    empleadosSeleccionados: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    loading: false,
    empleadosSelect: [],
    asignacionService: null,
    search: '',
    planillaOpciones: [],
    planilla: '',
    sexoOpciones: [
      { text: 'TODOS', value: '' },
      { text: 'FEMENINO', value: 'F' },
      { text: 'MASCULINO', value: 'M' }
    ],
    sexo: '',
    dni: '',
    cabeceraEmpleado: [
      { text: 'idplanilla', value: 'planillafipe' },
      { text: 'idtrabajador', value: 'idtrabajador' },
      { text: 'nombresall', value: 'nombresall' },
      { text: 'sexo', value: 'sexo' }
    ],
    empleados: []
  }),
  watch: {
    dialog(val) {
      if (val) {
        this.iniciaPlanilla();
        this.iniciaTrabajadores();
      }
    },
    planilla() {
      this.iniciaTrabajadores();
    },
    sexo() {
      this.iniciaTrabajadores();
    }
  },
  methods: {
    async iniciaPlanilla() {
      this.planilla = '';
      this.planillaOpciones = [];
      const res = await this.asignacionService.get().execResource('planillas', {
        idempresa: localStorage.getItem('emp')
      });
      if (res.length > 0) {
        this.planillaOpciones.push({ text: 'TODOS', value: '' });
        res.forEach((element) => {
          this.planillaOpciones.push({ text: element.idplanilla, value: element.idplanilla });
        });
        this.planilla = this.planillaOpciones[0].value;
      }
    },
    async iniciaTrabajadores() {
      this.loading = true;
      this.empleados = [];
      const res = await this.asignacionService.get().execResource('trabajadores', {
        idempresa: localStorage.getItem('emp'),
        idplanilla: this.planilla,
        sexo: this.sexo
      });
      if (res.length > 0) {
        this.empleados = res;
      }
      this.loading = false;
    },
    cancelar() {
      this.$emit('cancelar');
    },
    asignarEmpleados() {
      this.$emit('asignarEmpleados', [...this.empleadosSelect]);
    }
  },
  async mounted() {
    this.asignacionService = this.$httpService(new AsignacionService(), this);
  }
};
</script>

<style lang="scss">
.sel-popup .v-input__control {
  margin-top: 12px;
}
</style>
